import { useDispatch } from "react-redux"
import "./Box.css"
import { postCart } from "../Redux/Cart/action"
import { useDisclosure, useToast } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom"

function Box({item}){

    const dispatch=useDispatch()
    const { isOpen, onOpen, onClose } = useDisclosure()
    const toast = useToast()
    const nav=useNavigate()

    const handleAdd=(id)=>
    {
       dispatch(postCart({productId:id,quantity:1})).then(r=>{ 
       
        if(r.msg.msg)
        {
          toast({
            title: 'Product',
            description: r.msg.msg,
            status: 'success',
            duration: 9000,
            isClosable: true,
          })
          onClose()
        }
        else
        {
          toast({
            title: 'Error',
            description: r.msg,
            status: 'error',
            duration: 9000,
            isClosable: true,
          })

        }})
    }
    const handleChange=(id)=>
    {
      nav(`/product/singlePage/${id}`)
    }
    return(
    <div className="item">

        <div>
            <img className="img" src={item.image} alt="image" onClick={()=>handleChange(item._id)} />
        </div>

        <div className="cartbutton">
            <button onClick={()=>handleAdd(item._id)}>ADD TO CART</button>
        </div>

        <div className="Productsname">{item.product_name}</div>

        <div className="pricerating">
            <div>
                <b>₹ {item.d_price}</b>
            </div>
            <div className="price">{item.price}</div>
            <div className="offer">{item.offer}</div>
        </div>

        <div className="pricerating">
            <div className="rating">{item.rating}⭐️</div>
            <div className="ratingcount">{item.rating_count}</div>
        </div>
        
        <div></div>
    </div>
    )
}

export default Box